import { isDate } from 'lodash';
import formatDate from './formatDate';

const getDateTimePickerFormat = (date, formatStr) => {
  if (typeof date === 'string' && date) {
    const rawDate = new Date(date);
    const formattedDate = formatDate(rawDate, formatStr);

    return formattedDate;
  }

  if (isDate(date)) {
    const formattedDate = formatDate(date, formatStr);

    return formattedDate;
  }

  return date;
};

export default getDateTimePickerFormat;
